import React, { useCallback, useContext, useEffect, useState } from 'react';
import { UploadContext } from '../contexts/UploadContext';
import Button from './common/Button';
var PreviewVideo = function () {
    var _a = useContext(UploadContext), fileToUpload = _a.fileToUpload, setFileToUpload = _a.setFileToUpload, name = _a.name, description = _a.description, setName = _a.setName, setDescription = _a.setDescription, uploadFile = _a.uploadFile;
    var _b = useState(''), videoStream = _b[0], setVideoStream = _b[1];
    var getVideoStream = useCallback(function () {
        var reader = new FileReader();
        reader.onabort = function () { return console.log('file reading was aborted'); };
        reader.onerror = function () { return console.log('file reading has failed'); };
        reader.onload = function () {
            var binaryStr = reader.result;
            setVideoStream(binaryStr);
        };
        if (fileToUpload)
            reader.readAsDataURL(fileToUpload);
    }, []);
    useEffect(function () {
        getVideoStream();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "flex justify-center items-center mt-3" },
            React.createElement("div", { className: "h-80 block relative" }, videoStream &&
                React.createElement("video", { autoPlay: true, className: "h-full inset-0 object-cover object-top", controls: true },
                    React.createElement("source", { src: videoStream, type: "video/mp4" }),
                    "Your browser does not support the video tag.")),
            React.createElement("div", { className: "pl-10" },
                React.createElement("div", null,
                    React.createElement("label", null,
                        "Name:",
                        React.createElement("input", { type: "text", className: "border ml-4 pl-1 pt-1 w-64 text-white border-t-0 border-l-0 border-r-0 bg-gray-500 bg-opacity-40", value: name, onChange: function (e) { return setName(e.target.value); } }))),
                React.createElement("div", { className: "pt-4 w-full" },
                    React.createElement("label", null,
                        "Description:",
                        React.createElement("textarea", { className: "border w-full pl-2 pt-2 text-white border-t-0 border-l-0 border-r-0 bg-gray-500 bg-opacity-40", rows: 4, value: description, onChange: function (e) { return setDescription(e.target.value); } }))))),
        React.createElement("div", { className: "flex justify-center mt-2" },
            React.createElement(Button, { onClick: function () { return setFileToUpload(undefined); } }, "Change video"),
            fileToUpload && React.createElement(Button, { color: "green", onClick: uploadFile }, "Upload to Vimeo"))));
};
export default PreviewVideo;
